import { Checkbox as AntDCheckbox } from "antd";

function Checkbox({ item, rounded = true, color = "grey", variant, ...restProps }) {
  return (
    <AntDCheckbox
      {...restProps}
      value={item.value}
      className={`checkbox-checked-bg-violet ${restProps?.customClasses ?? ""} 
      ${variant && variant ? `hs-checkbox-${variant}` : ""}`}
    >
      <div className={`${color ? `hs-color-${color}` : ""}`}>{item?.label}</div>
    </AntDCheckbox>
  );
}

export default Checkbox;
